module.exports = __webpack_public_path__ + "static/pic2-6ef20e410c45a048ec64534fb657a376.jpg";